import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable()
export class RequestParserInterceptor implements HttpInterceptor {

  constructor(
    private notification: NzNotificationService,
    private translationService: TranslateService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    try {

      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.error instanceof ErrorEvent) {
            throw error;
          }

          const errorObj = error.error.errors;

          if (errorObj) {
            this.createNotifications(errorObj);
          }

          throw errorObj;
        })
      );
    } catch {
      return next.handle(request);
    }
  }

  /**
   * Una sola notifica per errore: la key fa da titolo, i messages da corpo.
   * (Prima veniva mostrato un toast per OGNI stringa, quindi key e messages
   * comparivano come notifiche separate e duplicate per lo stesso errore.)
   */
  private createNotifications(errors: NotificationResponseModel[]): void {
    for (const error of errors) {
      const keys: string[] = [error.key ?? '', ...(error.messages ?? [])].filter((key) => !!key);
      if (keys.length === 0) {
        continue;
      }

      this.translationService?.get(keys).subscribe((translations: Record<string, string>) => {
        const texts = keys.map((key) => translations[key] ?? key);
        const title = texts[0];
        const message = texts.slice(1).join(' ');

        this.notification.error(title, message);
      });
    }
  }
}

interface NotificationResponseModel {
  key?: string;
  messages?: string[];
}
